/**
 * Runtime configuration, fetched from /config.json.
 *
 * Deployed by CDK alongside the built bundle, so the same JavaScript runs against
 * any stack and no stack values are baked into the build.
 */

export interface AppConfig {
  region: string;
  userPoolId: string;
  clientId: string;
  /** Base URL of the SMS API (HTTP API), written by the SMS stack. */
  apiBaseUrl: string;
  /** Cognito hosted-UI domain, present when Entra staff sign-in is wired. */
  cognitoDomain?: string;
  /** Cognito identity-provider name for Entra ("Entra"), empty/absent when off. */
  entraProvider?: string;
}

export async function loadConfig(): Promise<AppConfig> {
  const response = await fetch("/config.json", { cache: "no-store" });
  if (!response.ok) {
    throw new Error(
      "Could not load config.json. Deploy the SMS stack with CDK first.",
    );
  }
  return (await response.json()) as AppConfig;
}
